'use strict';
/**
 * Thrown when the index is higher than the current length-1 of the array, or
 * lower than 0.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExOutOfBounds =
/** 
 * @param {Number} index The index out of bounds.
 * @param {Number} size The size of the array.
 */
function ExOutOfBounds(index, size) {
  _classCallCheck(this, ExOutOfBounds);

  this.index = index;
  this.size = size;
};

;
module.exports = ExOutOfBounds;